module.exports = __webpack_public_path__ + "b6c2f4d3c8129841a9a29e0f4b34430a.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_stacked_bar_6month_show.png
// module id = 908
// module chunks = 7